import { render, staticRenderFns } from "./vehiclesAddView.vue?vue&type=template&id=89a5e790&scoped=true&"
import script from "./vehiclesAddView.vue?vue&type=script&lang=js&"
export * from "./vehiclesAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a5e790",
  null
  
)

export default component.exports